import commands from '../core_plugins/commands';
import exampleTraces from '../core_plugins/example_traces';
import flagsPage from '../core_plugins/flags_page';
import flowEvents from '../core_plugins/flow_events';
import globalGroups from '../core_plugins/global_groups';
import notes from '../core_plugins/notes';
import settingsPage from '../core_plugins/settings_page';
import trackUtils from '../core_plugins/track_utils';

export default [
  commands,
  exampleTraces,
  flagsPage,
  flowEvents,
  globalGroups,
  notes,
  settingsPage,
  trackUtils,
];
